import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AssignedCommercial } from "@core/models/assigned-commercial.model";
import { Observable, shareReplay } from "rxjs";
import { EnvironmentService } from "../environment/environment.service";

@Injectable({
  providedIn: "root",
})
export class AssignedCommercialService {
  private readonly environment = inject(EnvironmentService);
  private readonly http = inject(HttpClient);

  private readonly API_URL = this.environment.getApiUrl();

  // Cache for the assigned commercial
  private cachedCommercial$: Observable<AssignedCommercial> | null = null;

  /**
   * Get the assigned commercial for the current client context.
   * Uses the current_client_id from the JWT token.
   * @returns Observable with the assigned commercial data
   */
  getMyAssignedCommercial(): Observable<AssignedCommercial> {
    return this.http.get<AssignedCommercial>(
      `${this.API_URL}v1/clients/my-assigned-commercial`
    );
  }

  /**
   * Get the assigned commercial with caching.
   * Caches the response to avoid multiple API calls during the session.
   * @returns Observable with the assigned commercial data
   */
  getCachedAssignedCommercial(): Observable<AssignedCommercial> {
    if (!this.cachedCommercial$) {
      this.cachedCommercial$ = this.getMyAssignedCommercial().pipe(
        shareReplay(1)
      );
    }
    return this.cachedCommercial$;
  }

  /**
   * Clear the cache to force a fresh fetch on next call.
   */
  clearCache(): void {
    this.cachedCommercial$ = null;
  }
}

